import { c as _c } from "react/compiler-runtime";
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiAgentV2ControllerCancelRequestMutationResponse, AiAgentV2ControllerCancelRequestPathParams } from "../../models/aiAgentV2Controller/AiAgentV2ControllerCancelRequest";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { aiAgentV2ControllerCancelRequest } from "../../clients/ai-agent-v2Service/aiAgentV2ControllerCancelRequest";
import { mutationOptions, useMutation } from "@tanstack/react-query";
export const aiAgentV2ControllerCancelRequestMutationKey = () => [{
  url: '/api/v1/ai-agent-v2/cancel/:requestId'
}] as const;
export type AiAgentV2ControllerCancelRequestMutationKey = ReturnType<typeof aiAgentV2ControllerCancelRequestMutationKey>;
export function aiAgentV2ControllerCancelRequestMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const mutationKey = aiAgentV2ControllerCancelRequestMutationKey();
  return mutationOptions<AiAgentV2ControllerCancelRequestMutationResponse, ResponseErrorConfig<Error>, {
    requestId: AiAgentV2ControllerCancelRequestPathParams["requestId"];
  }, TContext>({
    mutationKey,
    mutationFn: async ({
      requestId
    }) => {
      return aiAgentV2ControllerCancelRequest(requestId, config);
    }
  });
}

/**
 * @summary Cancel a running chat request
 * {@link /api/v1/ai-agent-v2/cancel/:requestId}
 */
export function useAiAgentV2ControllerCancelRequest(t0) {
  const $ = _c(19);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  let t2;
  if ($[2] !== options) {
    t2 = options ?? {};
    $[2] = options;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    mutation: t3,
    client: t4
  } = t2;
  let t5;
  if ($[4] !== t3) {
    t5 = t3 === undefined ? {} : t3;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const mutation = t5;
  let t6;
  if ($[6] !== t4) {
    t6 = t4 === undefined ? {} : t4;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const config = t6;
  let mutationOptions;
  let queryClient;
  if ($[8] !== mutation) {
    ({
      client: queryClient,
      ...mutationOptions
    } = mutation);
    $[8] = mutation;
    $[9] = mutationOptions;
    $[10] = queryClient;
  } else {
    mutationOptions = $[9];
    queryClient = $[10];
  }
  let t7;
  if ($[11] !== mutationOptions.mutationKey) {
    t7 = mutationOptions.mutationKey ?? aiAgentV2ControllerCancelRequestMutationKey();
    $[11] = mutationOptions.mutationKey;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const mutationKey = t7;
  let t8;
  if ($[13] !== config) {
    t8 = aiAgentV2ControllerCancelRequestMutationOptions(config);
    $[13] = config;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const baseOptions = t8 as UseMutationOptions<AiAgentV2ControllerCancelRequestMutationResponse, ResponseErrorConfig<Error>, {
    requestId: AiAgentV2ControllerCancelRequestPathParams["requestId"];
  }, TContext>;
  let t9;
  if ($[15] !== baseOptions || $[16] !== mutationKey || $[17] !== mutationOptions) {
    t9 = {
      ...baseOptions,
      mutationKey,
      ...mutationOptions
    };
    $[15] = baseOptions;
    $[16] = mutationKey;
    $[17] = mutationOptions;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return useMutation(t9, queryClient) as UseMutationResult<AiAgentV2ControllerCancelRequestMutationResponse, ResponseErrorConfig<Error>, {
    requestId: AiAgentV2ControllerCancelRequestPathParams["requestId"];
  }, TContext>;
}